import { render, staticRenderFns } from "./UnregisterClientButton.vue?vue&type=template&id=34fe419b&"
import script from "./UnregisterClientButton.vue?vue&type=script&lang=ts&"
export * from "./UnregisterClientButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports